import { zLogRocket } from '@zoll/logrocket-react-lib'

export const customizeSanitizers = () => {
  // create a fresh object of sanitizers for customization
  const sanitizers = zLogRocket.utilities.createSanitizers()

  /**
   * list of properties to sanitize,
   * when they have an exact and case sensitive match
   */
  sanitizers.anywhere.sanitizeExactMatch = ['Authorization']

  /**
   * list of properties to sanitize,
   * when they have a partial and case insensitive match
   */
  sanitizers.anywhere.sanitizeFuzzyMatch = [
    'ssn',
    'name',
    'middle',
    'phone',
    'birth',
    'dob',
    'addr',
    'zip',
    'city',
    'state',
    'email',
    'patient',
    'race',
    'gender',
    'employer',
    'auth',
    'token',
    'jwt',
    'cadData',
    'emcUrl',
    'narrative',
    'oracle',
    'oracleStatements',
    'password',
    'pcr',
    'pcrDocumentContent',
    'prid',
    'ptid',
    'sensitiveData',
    'files',
  ]

  /**
   * list of properties to ignore and not sanitize,
   * when they are recursively, exact and case sensitive matched
   */
  sanitizers.anywhere.ignoreExactMatch = []

  return sanitizers
}
